// extracted by mini-css-extract-plugin
export var modal = "_tz-0";
export var table = "_tz-1";